import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { CreateMilestoneError } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateMilestoneError;
  createMilestone(request: Boundaries["createMilestone"]["request"]): void;
}

function useCreateMilestone(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isMilestoneCreationRequestPending),
    isRequestSuccess: useSelector(selector.isMilestoneCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isMilestoneCreationRequestFailure),
    error: useSelector(selector.getCreateMilestoneError),
    createMilestone: core.createMilestone,
  };
}

export { useCreateMilestone };
